<div class="dismiss" [class.disabled]="disabled" (click)="onDismiss()">
    <i class="fas fa-times"></i>
</div>

<span class="content">
    <ng-content></ng-content>
</span>
